export function joinPath(left: string, right: string): string {
  left = ensureTrailingSlash(left);
  return left + right;
}

export function ensureTrailingSlash(str: string): string {
  if (str[str.length - 1] === '/') return str;

  return str + '/';
}